// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import MenuLink from './MenuLink';
import Icon from 'components/Icon';
import Link from 'components/Link';

// local
import styles from './MenuBar.pcss';

export default class MenuBar extends PureComponent {
  
  static propTypes = {
    activeLink: PropTypes.string,
    className: PropTypes.string,
    fullName: PropTypes.bool,
  }
  static defaultProps = {
    activeLink: '/',
    fullName: false,
  }
  
  isActive = (link) => {
    const { activeLink } = this.props;
    if (link === '/portfolio' && /^\/portfolio\/[^/]+$/.test(activeLink)) return true;
    return (link === activeLink);
  }
  
  // name = () => (this.props.fullName ? 'colby dauphinais' : 'cd');
  
  render() {
    const { className, fullName } = this.props;
    const classes = classnames(className, styles.menuBar);
  
    const nameClasses = classnames(styles.left, {
      [styles.showFullName]: fullName,
    });
  
    return (
      <div className={ classes }>
        <Link className={ nameClasses } to={ '/' }>
          <span className={ styles.fullName } title={ 'home' }>{ 'colby dauphinais' }</span>
          <span className={ styles.initials } title={ 'Colby Dauphinais' }>{ 'cd' }</span>
        </Link>
        <div className={ styles.right }>
          <MenuLink to={ '/' } active={ this.isActive('/') }  title={ 'home' }>
            <Icon className={ styles.homeIcon } type={ 'home' } />
          </MenuLink>
          <MenuLink to={ '/resume' } active={ this.isActive('/resume') } title={ 'resume' }>
            { 'Resume' }
          </MenuLink>
          <MenuLink to={ '/portfolio' } active={ this.isActive('/portfolio') } title={ 'portfolio' }>
            { 'Portfolio' }
          </MenuLink>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MenuBar/index.jsx